import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  helpIconButton: {
    padding: `0px ${theme.spacing(1)}px`,
  },
  icon: {
    width: 20,
    height: 20,
  }
}));

export default useStyles;
